namespace advisorop.components.advisor {
    
    export class AdvisorProposalsController{
        $router;     
        public proposals;
     
        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService) {                        
        }
        

        $onInit(): void {

         
            this.advisorService.getProposals().success((data) => {
                this.proposals = data;
            }).error((data, status) => {
                toastr.error("Proposals error: " + status + ":" + data);
            });
    
        }

        $routerOnActivate(next, previous) {            
        }        

    }



    class AdvisorProposals implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["identityService", "advisorService", AdvisorProposalsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-proposals.html';            
        }
    }
    angular.module(Constants.APP).component("advisorProposals", new AdvisorProposals());
    
}